import { useCallback, useEffect, useState } from "react";

import { useElementSize } from "usehooks-ts";

export const useContainerWidth = () => {
  const [containerRef, containerSize] = useElementSize<HTMLDivElement>();

  return [containerRef, containerSize.width] as const;
};
